export const text = {
  mobile: {
    md: {
      fontSize: '1rem',
      lineHeight: '1.5rem'
    },
    sm: {
      fontSize: '0.875rem',
      lineHeight: '1.3125rem'
    },
    xs: {
      fontSize: '0.75rem',
      lineHeight: '1rem'
    },
    xxs: {
      fontSize: '0.625rem',
      lineHeight: '1rem'
    },
    smallcaps: {
      fontSize: '0.8125rem',
      lineHeight: '1rem'
    },
    tableheading: {
      fontSize: '0.625rem',
      lineHeight: '1rem'
    }
  },
  desktop: {
    md: {
      fontSize: '1.25rem',
      lineHeight: '1.75rem'
    },
    sm: {
      fontSize: '1rem',
      lineHeight: '1.5rem'
    },
    xs: {
      fontSize: '0.75rem',
      lineHeight: '1rem'
    },
    xxs: {
      fontSize: '0.75rem',
      lineHeight: '1.3rem'
    },
    smallcaps: {
      fontSize: '0.8125rem',
      lineHeight: '1rem'
    },
    tableheading: {
      fontSize: '0.75rem',
      lineHeight: '1rem'
    }
  }
};

export const headings = {
  mobile: {
    xl: {
      fontSize: '2.5rem',
      lineHeight: '3rem'
    },
    lg: {
      fontSize: '2rem',
      lineHeight: '2.5rem'
    },
    md: {
      fontSize: '1.5rem',
      lineHeight: '2rem'
    },
    sm: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem'
    },
    xs: {
      fontSize: '1.15rem',
      lineHeight: '1.5rem'
    },
    xxs: {
      fontSize: '1rem',
      lineHeight: '1.5rem'
    },
    xxxs: {
      fontSize: '0.625rem',
      lineHeight: '1.5rem'
    }
  },
  desktop: {
    xl: {
      fontSize: '3.5rem',
      lineHeight: '4rem'
    },
    lg: {
      fontSize: '3rem',
      lineHeight: '3.5rem'
    },
    md: {
      fontSize: '2.5rem',
      lineHeight: '3rem'
    },
    sm: {
      fontSize: '2rem',
      lineHeight: '2.5rem'
    },
    xs: {
      fontSize: '1.5rem',
      lineHeight: '2rem'
    },
    xxs: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem'
    },
    xxxs: {
      fontSize: '0.75rem',
      lineHeight: '1.5rem'
    }
  }
};
